var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { Alert, Button, TextField } from '@mui/material';
import ConfirmDialog from '@shared/components/ConfirmDialog';
import { accountSwitchDestination, fetchAccountSwitchOptions, startAccountSwitchChallenge, switchAccount } from '@shared/api/employeeAccountLinkApi';
const AccountSwitchDialog = ({ target, companyPublicUid, onCancel }) => {
    const [password, setPassword] = useState('');
    const [provider, setProvider] = useState(null);
    const [loadingOptions, setLoadingOptions] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        let cancelled = false;
        fetchAccountSwitchOptions().then((options) => {
            if (!cancelled)
                setProvider(options.provider);
        }).catch((err) => {
            if (!cancelled)
                setError(err instanceof Error ? err.message : '再認証方法を取得できませんでした。');
        }).finally(() => {
            if (!cancelled)
                setLoadingOptions(false);
        });
        return () => { cancelled = true; };
    }, []);
    const authenticate = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (oauth = false) {
        setSubmitting(true);
        setError(null);
        try {
            if (oauth) {
                yield startAccountSwitchChallenge(target.public_uid, companyPublicUid);
            }
            else {
                yield switchAccount(target.public_uid, { current_password: password });
                window.location.href = accountSwitchDestination(companyPublicUid);
            }
        }
        catch (err) {
            setError(err instanceof Error ? err.message : 'アカウントの切り替えに失敗しました。');
            setPassword('');
            setSubmitting(false);
        }
    });
    return React.createElement(ConfirmDialog, { open: true, title: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u5207\u308A\u66FF\u3048", message: `${target.name}へ切り替えます。現在のアカウントで再認証してください。`, confirmLabel: "\u8A8D\u8A3C\u3057\u3066\u5207\u308A\u66FF\u3048\u308B", confirmDisabled: !password || loadingOptions, loading: submitting, onConfirm: () => void authenticate(), onCancel: () => { if (!submitting)
            onCancel(); } },
        error && React.createElement(Alert, { severity: "error", sx: { mt: 2 } }, error),
        React.createElement(TextField, { autoFocus: true, fullWidth: true, margin: "normal", label: "\u73FE\u5728\u306E\u30D1\u30B9\u30EF\u30FC\u30C9", type: "password", autoComplete: "current-password", value: password, disabled: submitting, onChange: (event) => setPassword(event.target.value) }),
        provider && React.createElement(Button, { fullWidth: true, variant: "outlined", disabled: submitting || loadingOptions, onClick: () => void authenticate(true) },
            provider,
            "\u3067\u518D\u8A8D\u8A3C"));
};
export default AccountSwitchDialog;
